import * as z from "zod/v4";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum ProductTagsFilterQuery {
  CONTAINS = "contains",
  NOT_CONTAINS = "notContains",
}

const ProductTagsFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.PRODUCT_TAGS,
  ProductTagsFilterQuery,
  z.array(z.string()),
);
export const ProductTagsFilterSchema: z.ZodType<ProductTagsFilter> =
  ProductTagsFilterSchema_;
export interface ProductTagsFilter
  extends z.infer<typeof ProductTagsFilterSchema_> {}
